import api from './api';

// Admin › Infra › Streaming Clients — the hub-run streaming consumers (containers/ohip-events on EKS), served by code-eks'
// streaming-clients lambda. A client is named by its key: pl-<implementation id>, sp-<sync project id>, or
// <namespace>.<deployment> for a Deployment nothing in the database accounts for.
const enc = encodeURIComponent;
const streamingClientsService = {
    list:         ()           => api.get('/admin/streaming-clients'),
    // One client, with the credential and the values a deploy would use (`resolved`) and what is `missing`.
    get:          (key)        => api.get(`/admin/streaming-clients/${enc(key)}`),
    saveSettings: (key, body)  => api.put(`/admin/streaming-clients/${enc(key)}`, body),
    // Deploy or redeploy. Settings in the body (chainCode, hotelCode, logLevel) are saved first.
    deploy:       (key, body)  => api.post(`/admin/streaming-clients/${enc(key)}/deploy`, body || {}),
    stop:         (key)        => api.post(`/admin/streaming-clients/${enc(key)}/stop`, {}),
    // { tailLines } for the first read, { sinceTime } to continue a tail, { previous: true } for the crashed instance.
    // The first read is audited as a READ (the consumer logs OHIP events); the tail's follow-ups are not.
    logs:         (key, params) => api.get(`/admin/streaming-clients/${enc(key)}/logs`, { params }),
};

export default streamingClientsService;
